import React from "react";
import { Card, CardBody, Table, Badge, Button } from "reactstrap";
import { injectIntl } from "react-intl";
import moment from "moment";

const StockReturnList = ({ intl, data = [], onViewDetail }) => {
  const getStatusBadge = (status) => {
    switch (status) {
      case "pending":
        return <Badge color="warning">Đang xử lý</Badge>;
      case "completed":
        return <Badge color="success">Hoàn thành</Badge>;
      default:
        return <Badge color="light">{status}</Badge>;
    }
  };

  const formatCurrency = (value) => {
    return new Intl.NumberFormat("vi-VN", {
      style: "currency",
      currency: "VND",
    }).format(value || 0);
  };

  if (data.length === 0) {
    return (
      <Card className="mb-4">
        <CardBody className="text-center text-muted">
          <i className="iconsminds-back" style={{ fontSize: "48px" }}></i>
          <p className="mt-3">Chưa có phiếu hoàn hàng nào</p>
        </CardBody>
      </Card>
    );
  }

  return (
    <Card className="mb-4">
      <CardBody>
        <Table hover responsive>
          <thead>
            <tr>
              <th>Mã phiếu</th>
              <th>Ngày hoàn</th>
              <th>Nhà cung cấp</th>
              <th className="text-center">Số nguyên liệu</th>
              <th className="text-right">Tổng giá trị</th>
              <th className="text-center">Trạng thái</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            {data.map((item) => (
              <tr key={item.id}>
                <td style={{ verticalAlign: "middle" }}>
                  <strong>{item.return_code}</strong>
                </td>
                <td style={{ verticalAlign: "middle" }}>
                  {moment(item.return_date).format("DD/MM/YYYY")}
                </td>
                <td style={{ verticalAlign: "middle" }}>
                  {[
                    ...new Set(
                      item.items?.map((i) => i.provider?.name).filter(Boolean)
                    ),
                  ].join(", ") || "-"}
                </td>
                <td className="text-center" style={{ verticalAlign: "middle" }}>
                  {item.items?.length || 0}
                </td>
                <td className="text-right" style={{ verticalAlign: "middle" }}>
                  {formatCurrency(item.total_value)}
                </td>
                <td className="text-center" style={{ verticalAlign: "middle" }}>
                  {getStatusBadge(item.status)}
                </td>
                <td className="text-center" style={{ verticalAlign: "middle" }}>
                  <Button
                    color="link"
                    size="sm"
                    onClick={() => onViewDetail && onViewDetail(item)}
                  >
                    Chi tiết
                  </Button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </CardBody>
    </Card>
  );
};

export default injectIntl(StockReturnList);
